import { KnowledgeAssetSubTypeEnum } from '@/types/schema';

import { convertStringToEnum } from '../types';
import CustomerStoryDetails from './CustomerStoryDetails';
import PersonaDetails from './PersonaDetails';
import PersonaJourneyDetails from './PersonaJourneyDetails';
import SalesConversationDetails from './SalesConversationDetails';
import SolutionDetails from './SolutionDetails';
import SolutionWinDetails from './SolutionWinDetails';

const KnowledgeAssetDetails = ({
  type,
  assetId,
  isPreview = false,
}: {
  type: string;
  assetId: string;
  isPreview?: boolean;
}) => {
  const assetType = convertStringToEnum(type, KnowledgeAssetSubTypeEnum);

  switch (assetType) {
    case KnowledgeAssetSubTypeEnum.Persona:
      return <PersonaDetails assetId={assetId} isPreview={isPreview} />;
    case KnowledgeAssetSubTypeEnum.PersonaJourney:
      return <PersonaJourneyDetails assetId={assetId} isPreview={isPreview} />;
    case KnowledgeAssetSubTypeEnum.CustomerStory:
      return <CustomerStoryDetails assetId={assetId} isPreview={isPreview} />;
    case KnowledgeAssetSubTypeEnum.SalesConversation:
      return <SalesConversationDetails assetId={assetId} isPreview={isPreview} />;
    case KnowledgeAssetSubTypeEnum.Solution:
      return <SolutionDetails assetId={assetId} isPreview={isPreview} />;
    case KnowledgeAssetSubTypeEnum.SolutionWin:
      return <SolutionWinDetails assetId={assetId} isPreview={isPreview} />;
    default:
      return null;
  }
};

export default KnowledgeAssetDetails;
